const path = require("path");
const slash = require("slash");

/**
 *  Used to construct the create content function. Which in turn is used to build the items and streams pages.
 *
 * @param {Object} options
 * @param {string} options.hubId AirTable ID of the hub
 * @param {string} options.market market that the content is in [US, UK, etc.]
 * @param {string} options.featuredSlug slug of stream to use at root
 * @param {string} options.resourcesRoot path to use for resources root
 * @param {string} options.contentRoot path to use for content root
 * @param {boolean} [options.removeTrailingSlash] builds paths w/o trailing slash
 */
const createContentFactory = ({
    hubId,
    market,
    featuredSlug,
    resourcesRoot,
    contentRoot,
    removeTrailingSlash = false
}) => (graphql, createPage) => {
    const query = `
  {
    streams: allAirtable(
      filter: {
        table: { eq: "Streams" }
        data: { 
          hubs: { eq: "${hubId}" }
          market: { eq: "${market}" }
        }
      }
    ) {
      edges {
        node {
          id
          data {
            url_slug
            items
          }
        }
      }
    }
    items: allAirtable(
      filter: {
        table: { eq: "Items" }
        data: { 
          hubs: { eq: "${hubId}" }
          market: { eq: "${market}" }
        }
      }
    ) {
      edges {
        node {
          id
          data {
            url_slug
            streams
          }
        }
      }
    }
  }
  `;
    return graphql(query).then((result) => {
        const { streams, items } = result.data;

        // Error handling
        if (result.errors) {
            throw result.errors;
        }
        if (streams === null || items === null) {
            throw new Error("The graphQl query for streams or items failed. Please debug. AirTable?");
        }

        const trailingSlash = removeTrailingSlash ? "" : "/";

        const getItemIds = (itemsList) => (itemsList ? itemsList.map((rawId) => `Airtable_${rawId}`) : []);

        // main index pages with cards of items
        const resourcesTemplate = path.resolve("./src/templates/resources/index.jsx");
        // index page/stream
        const featuredStream = streams.edges.find((edge) => edge.node.data.url_slug === featuredSlug);
        const itemIds = getItemIds(featuredStream.node.data.items);
        const rootPath = removeTrailingSlash ? resourcesRoot.replace(/\/$/, "") : resourcesRoot;
        createPage({
            path: rootPath,
            component: slash(resourcesTemplate),
            context: {
                // id: featuredStream.node.id.split("Airtable_")[1],
                id: featuredStream.node.id,
                recordId: featuredStream.node.recordId,
                rawId: featuredStream.node.id,
                itemIds
            }
        });

        // all other streams
        streams.edges.forEach((edge) => {
            // const id = edge.node.id.split("Airtable_")[1];
            const { id } = edge.node;
            const streamItemIds = getItemIds(edge.node.data.items);
            const streamPath = `${resourcesRoot}${edge.node.data.url_slug}${trailingSlash}`;
            createPage({
                path: streamPath,
                component: slash(resourcesTemplate),
                context: {
                    id,
                    recordId: edge.node.recordId,
                    rawId: edge.node.id,
                    itemIds: streamItemIds
                }
            });
        });

        // individual details pages for content/item
        const contentTemplate = path.resolve("./src/templates/content/index.jsx");
        items.edges.forEach((edge) => {
            // skip if no streams
            if (!edge.node.data.streams) return;
            // const id = edge.node.id.split("Airtable_")[1];
            const itemsId = edge.node.id;
            const itemPath = `${contentRoot}${edge.node.data.url_slug}${trailingSlash}`;
            createPage({
                path: itemPath,
                component: slash(contentTemplate),
                context: {
                    id: itemsId,
                    recordId: edge.node.recordId,
                    rawId: edge.node.id,
                    streamId: edge.node.data.streams[0]
                }
            });
        });
    });
};

module.exports = { createContentFactory };
